<template>
	<v-card v-for="(data, index) in breaksData.activities" :key="index" variant="outlined" rounded="lg" elevation="0" class="break-card pa-3">
		<div class="mb-2 mx-1">
			<span class="text-error font-weight-medium mr-2"> {{ formatLabel(breaksData.label) }} </span>
			<div class="d-flex align-center mr-6 text-medium-emphasis break-stat pt-2">
				<v-icon size="10" class="mr-1"> mdi-timer-sand </v-icon>
				<span class="text-caption">{{ formatSecondsDurationToHM(formatTimeToSeconds(data.endTime) - formatTimeToSeconds(data.startTime)) }}</span>
			</div>
		</div>

		<div class="text-medium-emphasis">
			<span class="text-style"> {{ data.activity }} </span>
			<div class="d-flex align-center break-stat pt-2">
				<v-icon size="10" class="mr-1"> mdi-clock-outline </v-icon>
				<span class="text-caption"> {{ data.startTime }} - {{ data.endTime }} </span>
			</div>
		</div>
	</v-card>
</template>

<script setup lang="ts">
import { DutyActivityGroup } from '@/rennovation/planning-view/types/api/duties-response';
import useDateTime from '../../../../../../../components/composables/useDateTime.js';

const props = withDefaults(
	defineProps<{
		breaksData: DutyActivityGroup;
	}>(),
	{}
);

const { formatTimeToSeconds, formatSecondsDurationToHM } = useDateTime();

const formatLabel = (label) => {
	const defaultLabel = 'Pause';
	return label || defaultLabel;
};
</script>

<style scoped>
.break-card {
	background: #fffcfc;
	border-color: #ffe5e5;
	display: flex;
}

.text-style {
	font-family: Roboto, sans-serif;
	font-size: 12px;
	line-height: 150%;
	font-weight: 400;
	color: #000000;
}

.break-stat .text-caption {
	font-size: 14px;
	font-family: Roboto, sans-serif;
	font-weight: 500;
	letter-spacing: 0 !important;
	line-height: 150%;
}
</style>